import React, { PropTypes } from 'react';
import { Link, IndexLink } from 'react-router';
import CasoTable from './CasoTable';
import Navi from './Navi';


class Dashboard extends React.Component {


  render () {
    return(
      <div className="container">
      <Navi />
      <div className="row">
      {this.props.children}
      </div>
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js